import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Loader from '~components/Loader'
import Card from '~components/Card'
import BrandLink from '~components/BrandLink'
import Banner from '~components/Banner'
import { loadContent } from '~redux/content'
import { loadFeaturedCategories } from '~redux/shop'
import { pageView } from '~helpers/ga'

class ShopIndex extends React.Component {
  componentDidMount () {
    pageView()

    this.props.loadContent('shop')
    this.props.loadFeaturedCategories()
  }

  render () {
    if (!this.props.content || !this.props.brands || !this.props.featuredCategories) {
      return <Loader />
    }

    return (
      <>
        <Banner
          className="mt-2 lg:mt-10"
          title={this.props.content.fields.hero_title}
          text={this.props.content.fields.hero_text}
          image={
            {
              thumb: this.props.content.fields.hero_image.thumb,
              md: this.props.content.fields.hero_image.md,
              lg: this.props.content.fields.hero_image.lg,
              alt: 'Placeholder'
            }
          }
          link={
            {
              url: this.props.content.fields.hero_link,
              title: this.props.content.fields.hero_button_text
            }
          }
        />

        <section className="xxl:container mx-auto px-4 md:px-8 xxl:px-0 my-10 xl:my-20">
          <h2 className="mb-5 md:mb-10">
            Brands
          </h2>

          <div className="flex flex-wrap -my-1 -mx-1 md:-mx-2 md:-my-3 xxl:-mx-5 xl:-my-10">
            {this.props.brands.map(brand => (
              <div className="w-1/2 md:w-1/3 lg:w-1/5 px-1 md:px-2 xxl:px-5 my-1 md:my-3 xl:my-10" key={brand.id}>
                <BrandLink
                  title={brand.name}
                  image={{
                    src: brand.image_url, // 276x207
                    alt: brand.name
                  }}
                  url={`/shop/brands/${brand.slug}`}
                />
              </div>
            ))}
          </div>
        </section>

        {this.props.featuredCategories.map(category => (
          <section key={category.id} className="xxl:container mx-auto px-4 md:px-8 xxl:px-0 mb-10 xl:mb-20">
            <h2 className="mb-5 md:mb-10">
              {category.name}
            </h2>

            <div className="flex flex-wrap -mx-1 md:-mx-2 lg:-mx-4 xl:-mx-5 -my-5 xl:-my-10">
              {category.products.map(product => {
                const mainImage = product.images.find(i => i.is_thumbnail)

                return (
                  <div className="w-1/2 md:w-1/3 xl:w-1/4 px-1 md:px-2 lg:px-4 xl:px-5 my-5 xl:my-10" key={product.id}>
                    <Card
                      image={{
                        src: mainImage ? mainImage.url_standard : null,
                        alt: product.name
                      }}
                      subtitle={product.custom_fields.brand}
                      title={product.name}
                      url={product.range_url}
                      colour={product.custom_fields.colour}
                      styleCode={product.custom_fields.style_code}
                    />
                  </div>
                )
              })}
            </div>
          </section>
        ))}
      </>
    )
  }
}

ShopIndex.propTypes = {
  match: PropTypes.object,
  brands: PropTypes.arrayOf(PropTypes.object),
  content: PropTypes.object,
  featuredCategories: PropTypes.array,
  loadContent: PropTypes.func,
  loadFeaturedCategories: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    brands: state.shop.brands,
    content: state.content.shop || null,
    featuredCategories: state.shop.featuredCategories
  }
}

const mapDispatchToProps = dispatch => ({
  loadContent: page => { dispatch(loadContent(page)) },
  loadFeaturedCategories: () => { dispatch(loadFeaturedCategories()) }
})

export default connect(mapStateToProps, mapDispatchToProps)(ShopIndex)
